module.exports = __webpack_public_path__ + "img/TVAPLogo2019.afaf3736.png";